require('../../modules/es6.number.parse-int');
module.exports = require('../../modules/_core').Number.parseInt;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/parse-int.js
// module id = 140
// module chunks = 0